import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressSitelistApiSiteListServiceV2Url(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www._base_domain_': [
      {
        srcPath: '/_api/sites-list',
        destPath: '/api',
      },
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'feedback._base_domain_': [
      {
        srcPath: '/_api/sites-list',
        destPath: '/api',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/sites-list',
        destPath: '/api',
      },
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
      {
        srcPath: '/_api/sites-list-data',
        destPath: '/api/sites-list-data',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/site-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/sites-list',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'online.codux.com': [
      {
        srcPath: '/_api/sites-list',
        destPath: '',
      },
      {
        srcPath: '/_api/sites-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/site-list/v2/sites',
        destPath: '/v2/sites',
      },
    ],
    'vibe._base_domain_': [
      {
        srcPath: '/_api/sites-list',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_sites_sites';

/**
 * Retrieves a list of up to 100 sites per request, given the provided paging, sorting and filtering.
 *
 * > **Important**: You can only call this method when authenticated as a Wix user or by using an account level API key.
 */
export function querySites(payload: object): RequestOptionsFactory<any> {
  function __querySites({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.site_list.v2.site',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.sitelist.api.SiteListServiceV2.QuerySites',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressSitelistApiSiteListServiceV2Url({
        protoPath: '/v2/sites/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'sites.createdDate' },
              { path: 'sites.updatedDate' },
              { path: 'sites.trashedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __querySites;
}

/**
 * Retrieves the number of sites, given the provided filtering.
 * See [Query Sites](https://dev.wix.com/docs/rest/account-level-apis/sites/sites/query-sites) for a list of supported filters.
 *
 * > **Important**: You can only call this method when authenticated as a Wix user or by using an account level API key.
 */
export function countSites(payload: object): RequestOptionsFactory<any> {
  function __countSites({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.site_list.v2.site',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.sitelist.api.SiteListServiceV2.CountSites',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressSitelistApiSiteListServiceV2Url({
        protoPath: '/v2/sites/count',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __countSites;
}
